'use strict';
const mmWidgets = require('../widgets/mm-widgets');
mmWidgets.fn.clipboardActionWidget = function () {
	return mmWidgets.each(this, function () {
		const widget = this;
		widget.on('click', function (e) {
			const action = e.currentTarget.getAttribute('data-mm-clipboard-action');
			e.currentTarget.ownerDocument.execCommand(action);
			widget.addClass('success');
		});
		widget.on('transitionend', () => {
			widget.removeClass('success');
		});
	});
};


